import { Injectable } from '@angular/core';
import { IActiveChat } from '../models/chat.model';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  activeChats: IActiveChat[] = [];
  disableChat = new Subject<any>();
  openChat = new Subject<any>();

  constructor() {

  }
}
